import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { API_BASE_URL_TOKEN } from '@nebula-shared/data-access';
import { FormatoContableDetalle } from '../../domain/accounting-account.model';
// 👆 importa, NO declares aquí

@Injectable({ providedIn: 'root' })
export class AccountingAccountsService {
  private readonly http = inject(HttpClient);

  /** API del ambiente en que corre el front; con la de DEV fija, QA consultaba los formatos de DEV (Mantis #338). */
  private readonly baseUrl = `${inject(API_BASE_URL_TOKEN)}/nebula-accounting-core/api/v1/formatos-contables`;

  getDetailAccounts(formatoId: number): Observable<FormatoContableDetalle | null> {
    return this.http
      .get<any>(`${this.baseUrl}/get-record`, { params: { id: String(formatoId) } })
      .pipe(
        map((res) => {
          console.log('res', res);
          const data = res?.response?.content?.[0] ?? res?.response?.content ?? res?.content ?? res;

          if (!data?.id) return null;

          return {
            id: data.id,
            nombre: data.nombre,
            cuentasContables: data.cuentasContables ?? [],
          } as FormatoContableDetalle;
        }),
      );
  }
}
